module.exports = __webpack_public_path__ + "img/icon_copy.528c61eb.png";